
/**
@ngdoc directive
@name excludeFieldValidation

@description
This directives disables field from impacting the whole form validation state.<br />
In short words - field may be invalid, but the whole form still be valid.<br />
Warning! It removes the field from the form (ng-form).<br />
<br />
The directive source:<br />
http://stackoverflow.com/questions/21621192/validation-of-invisible-and-disabled-fields-in-angularjs<br />
<br />
Please mind! - once the validation  the fields will be unregistered from your form (ng-form)!<br />
So - for example - you will not have the access to it from your template (you may want to register it in the [directive] scope to have the access).
@usage
<input type="number" name="fieldName" class="form-control"
    ng-model="formModel.model"
    xms-validation max="100"
    exclude-field-validation="true"
/>

*/

(function() {
  'use strict';

var excludeFieldValidation = function($timeout, formFieldFactory) {
    return {
        restrict: 'A',
        require: '^form',
        priority: 200, // post link has to be run AFTER xms-validation http://stackoverflow.com/questions/22389094/directive-priority-in-angular-not-working
        link: function(scope, element, attrs, form) {
            var control;

            $timeout(function(){ // timeout is necessary for dynamic field names
                scope.$watch(function() {
                    return scope.$eval(attrs.excludeFieldValidation);
                }, function(value) {
                    if (!control) {
                        control = form[element.attr("name")];
                    }
                    if (value === false) {
                        formFieldFactory.formRegister(control, form);
                    } else {
                        formFieldFactory.formUnregister(control, form);
                    }
                });
            },0); // $timeout end
        }
    }
}
excludeFieldValidation.$inject = ['$timeout', 'formFieldFactory'];
angular.module('app').directive('excludeFieldValidation', excludeFieldValidation);

}());
